view_handler = {

    properties: {
        title: 'View/Add Comments',
        id: '',
        type: '',
        wordLimit: 300
    },

    onLoad: function(){
        var self = this;
        $('#content-root').addClass('noswipe');

        map.closePopup();


        var type = window.location.hash.substring(2).split('/')[1];
        var id = window.location.hash.substring(2).split('/')[2];

        self.properties.type = type;
        self.properties.id = id;

        //check to see if this feature exists
        if (!mapData.geoJSONData[type][id]){
            window.location.href = "#/";
        }
        else {
            map.invalidateSize();
            self.getData();
        }


    },

    getData: function(){
        var self = this;
        var type = self.properties.type;
        var id = self.properties.id;

        var data = mapData.geoJSONData[type][id];


        //Set Suggestion's initial comment
        if (type == 'existingtrail'){
            $('.feature-title').text(data.NAME);

            $('.suggestion-comment').html('<p class="no-mp">'+
              '</p>');

            $('.suggestion-comment').removeClass('hidden');
        }

        else if (type == 'plannedtrail'){
            $('.feature-title').text(data.NAME);

            $('.suggestion-comment').html('<p class="no-mp">'+
                '</p>');

            $('.suggestion-comment').removeClass('hidden');
        }

        else if (type == 'suggestions'){
            $('.feature-title').text(properties.selectCategories[data.category].title);

            if (data.comment){
                $('.suggestion-comment').html('<p class="no-mp">"' + data.comment + ' - ' + data.name + '"</p>').removeClass('hidden');
            }

        }

        self.getLikes();
        self.getComments();

    },

    formatText: function(comment) {
        comment = comment.replace(/(<([^>]+)>)/gi, "");
        if ($.trim(comment).length > 0) {
            return comment;
        }
        return "";
    },

    wordCount: function( val ){
        var wom = val.match(/\S+/g);
        return val.length || 0;
        // return wom ? wom.length : 0;
    },

    getLikes: function(){
        var self = this;
        var id = self.properties.id;
        var type = self.properties.type;
        if (type == 'suggestions'){
            type = mapData.geoJSONData.suggestions[id].category;
        }

        if (id){
            var likesNum = mapData.likes[type][id] || 0;
            $('.view-like').html(home_handler.fixedLikes(likesNum) + self.likeBtn(id)).removeClass('hidden');
            $('.add-like').click(function(event) {
                home_handler.addLike(id, type, true);
                event.preventDefault();
            });
        }
    },

    likeBtn: function(marker) {
        if (marker in mapData.pvlk){
          return '';
        }
        else {
          return ' <br><a class="add-like" href="#">+ Like This</a>'
        }
    },

    getComments: function(){

        var self = this;
        $('.comments').html('');

        //Set Comments
        $.ajax({
            type: "GET",
            url: mapData.commentsURL + '?sid=' + self.properties.id,
            cache: false,
            dataType: "json",
            success: function(json) {

                if (!json.error) {

                    $.each(json, function(index, value) {
                        $('.comments').append('<p>"'+value.comment+'" - <b>'+value.name+'</b></p>')
                    });

                }
                else {
                    $('.comments').addClass('hidden');
                }

            },
            error: function(xhr, textStatus, errorThrown) {
            }
        });

    },

    formSubmit: function(event) {
        $('#submit').prop('disabled', true);

        var self = this;
        var underLimit = self.wordCount($('textarea[name=comment]').val()) <= self.properties.wordLimit;


        if (underLimit){
            var formData = {
                'name': self.formatText($('input[name=name]').val()) || 'Anonymous',
                'comment': self.formatText($('textarea[name=comment]').val()),
                'sid': self.properties.id,
                'type': self.properties.type
            };

            $.ajax({
                type: "POST",
                url: mapData.commentsURL,
                crossDomain: false,
                data: formData,
                success: function(json) {
                    $('#submit').prop('disabled', false);
                    if (json.error) {
                        alert('server error');

                    } else {
                        $("#comment-submit").fadeOut('500', function() {
                            $("#comment-submit").remove();
                            self.getComments();
                            $('.comments').addClass('expanded').removeClass('hidden');

                        });
                        // window.location.href = "#/step-three/";
                    }
                },
                error: function(xhr, textStatus, errorThrown) {
                    $('#submit').prop('disabled', false);
                    alert('error');
                }
            });
        }
        else {
            $('#submit').prop('disabled', false);
        }


        event.preventDefault();
    },

    events: function() {
        var self = this;
        self.onLoad();

        $("#comment-submit").submit(function(event) {
            self.formSubmit(event);
        });

        $('.content-close-btn').click(function(event) {
            map.closePopup();
            mapData.selectLayer.clearLayers();
            window.location.href = "#/" + properties.previousURL;
            return false;
        });

        $('textarea[name=comment]').on('input click', function() {
            var wordCount = self.wordCount($(this).val());
            if (wordCount > self.properties.wordLimit){
                $('.story-word').text(self.properties.wordLimit);
                $(this).addClass('required');
                $('.story-min').addClass('required');
            }
            else {
                $('.story-min').removeClass('required');
                $(this).removeClass('required');
                $('.story-word').text(wordCount);
            }
        });


    }
}